var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 8.58594C10.5781 8.58594 10.6719 8.61523 10.7266 8.67383C10.7852 8.72852 10.8145 8.82227 10.8145 8.95508V12.7988H12.4609C12.5547 12.7988 12.627 12.8164 12.6777 12.8516C12.7285 12.8828 12.7656 12.9414 12.7891 13.0273C12.8164 13.1133 12.8301 13.2383 12.8301 13.4023C12.8301 13.5664 12.8164 13.6914 12.7891 13.7773C12.7656 13.8633 12.7285 13.9219 12.6777 13.9531C12.627 13.9844 12.5547 14 12.4609 14H7.75C7.65625 14 7.58398 13.9844 7.5332 13.9531C7.48242 13.9219 7.44336 13.8633 7.41602 13.7773C7.39258 13.6914 7.38086 13.5664 7.38086 13.4023C7.38086 13.2383 7.39258 13.1133 7.41602 13.0273C7.44336 12.9414 7.48242 12.8828 7.5332 12.8516C7.58398 12.8164 7.65625 12.7988 7.75 12.7988H9.34961V9.78711H8.10156C8.00781 9.78711 7.93555 9.77148 7.88477 9.74023C7.83398 9.70898 7.79492 9.65039 7.76758 9.56445C7.74414 9.47852 7.73242 9.35352 7.73242 9.18945C7.73242 9.02539 7.74414 8.90039 7.76758 8.81445C7.79492 8.72852 7.83398 8.66992 7.88477 8.63867C7.93555 8.60352 8.00781 8.58594 8.10156 8.58594H10.4453ZM10.0645 6.01367C10.3418 6.01367 10.5352 6.04297 10.6445 6.10156C10.7578 6.15625 10.8145 6.25 10.8145 6.38281V7.34375C10.8145 7.47656 10.7617 7.57227 10.6562 7.63086C10.5547 7.68555 10.3672 7.71289 10.0938 7.71289C9.82031 7.71289 9.62695 7.68555 9.51367 7.63086C9.4043 7.57227 9.34961 7.47656 9.34961 7.34375V6.38281C9.34961 6.24609 9.40039 6.15039 9.50195 6.0957C9.60352 6.04102 9.79102 6.01367 10.0645 6.01367Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.4a6da92fbf56c05eab0758c80364dedc.svg";
export { ForwardRef as ReactComponent };